<template>
  <div>
    <ValidationObserver class="row">
      <div class="col-3">
        <info title="Nombre:">
          <ValidationProvider
            v-slot="{ errors }"
            name="nombre"
            rules="required"
          >
            <CustomInput
              id="txtContactName"
              v-model="contactInformation.contactName"
              required
              :error="errors[0]"
              :custom-error-msg="errors[0]"
            />
          </ValidationProvider>
        </info>
      </div>
      <div class="col-3">
        <info title="Parentesco:">
          <ValidationProvider
            v-slot="{ errors }"
            name="parentesco"
            rules="required"
          >
            <custom-drop-down
              id="ddlSelectedRelationship"
              v-model="contactInformation.contactRelation"
              fieldname="spaShortDescription"
              fieldkey="eduespCodeId"
              :options="relationships"
              placeholder="Seleccione"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
            />
          </ValidationProvider>
        </info>
      </div>
      <div class="col-3">
        <info title="Email:">
          <ValidationProvider v-slot="{ errors }" name="email" rules="required">
            <CustomInput
              id="txtContactEmail"
              v-model="contactInformation.contactEmail"
              required
              :error="errors[0]"
              :custom-error-msg="errors[0]"
            />
          </ValidationProvider>
        </info>
      </div>
      <div class="col-3">
        <info title="Teléfono:">
          <ValidationProvider
            v-slot="{ errors }"
            name="teléfono"
            rules="required"
          >
            <CustomInput
              id="txtContactTelephone"
              v-model="contactInformation.contactTelephone"
              mask-type="Phone"
              :masked="false"
              placeholder="(__) __-____"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
            />
          </ValidationProvider>
        </info>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import Info from './Info.vue';
import CustomInput from '@/components/common/CustomInput';
import CustomDropDown from '@/components/common/CustomDropDown';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  components: {
    Info,
    CustomInput,
    CustomDropDown,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    contactInformation: { type: Object, require: true, default: () => ({}) },
    relationships: { type: Array, require: true, default: () => [] },
  },
  data() {
    return {
      info: { StudentContactInformation: {} },
      selectedRelationship: null,
    };
  },
};
</script>

<style></style>
